export const AiCheckMissingFields = {
    "lot_number": "Lot Number",
    "product_name": "Product Name",
    "import_date": "Date of Import",
    "import_from_country": "Import Country",
    "export_date": "Date of Export",
    "export_to_country": "Export Country",
    "metric_tonnes": "Quantity (Metric Tonnes)",
    "origin_country": "Country of Origin",
    "dds_reference": "DDS Reference Number",
    "hs_code": "HS Code",
    "kn_code": "KN Code",
    "taric_code": "TARIC Code",
    "fiscal_year": "Financial Year",
    "supplier_name": "Supplier Name",
    "supplier_vat": "VAT Number",
    "supplier_eori": "EORI",
    "country": "Country",
    "city": "City",
    "street": "Street",
    "zip_code": "Postal Code",
    "client_id": "Mandate ID",
    "account_id": "Account ID",
    "unmatched_products_pct": "Unmatched Products",
    "unmatched_suppliers_pct": "Unmatched Suppliers",
    "internal_product_id": "Internal Product ID",
    "internal_sku": "Internal SKU"
}